ready = ->
  return unless continueIfAllowed('access_tokens', ['technician_app'])

  technicianAppLogsTable = $('#access_tokens_technician_app').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    searching: false
    iDisplayLength: 50
    sAjaxSource: $('#access_tokens_technician_app').data('source')
    order: [ [ 0, "asc" ] ]
    bAutoWidth: false
    fixedColumns: true
    aoColumnDefs:
      [{ 'bSortable': false, 'aTargets': [] }]
    columns: [
      { "width": "25%"}
      { "width": "25%"}
      { "width": "15%"}
      { "width": "25%"}
      { "width": "15%"}
    ]

$(document).ready(ready)
